import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';
import { cn } from '@/lib/cn';

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

interface TooltipContentProps extends React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> {
  /** Render a small arrow pointing at the trigger (default false). */
  arrow?: boolean;
}

// Original tooltip surface (InfoHint): tertiary surface, xs text, portalled above dialogs.
const TooltipContent = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, TooltipContentProps>(
  ({ className, sideOffset = 4, arrow = false, children, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          'z-[70] max-w-[16rem] rounded-lg border border-border bg-muted px-2.5 py-1.5 text-xs text-foreground shadow-xl data-[state=delayed-open]:animate-dropdown-in data-[state=instant-open]:animate-dropdown-in',
          className,
        )}
        {...props}
      >
        {children}
        {arrow && <TooltipPrimitive.Arrow className="fill-muted" />}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  ),
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
